var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import "blocks/AggregatesIncidentsBlock/ui/AggregatesIncidentsBlock.less";
import { IconTypes, BadgeTypes } from "../../../constants";
import { IncidentItem } from "../../../components";
import { getPropertyValueOrDefault } from "../../../helpers";
import { Message } from "sb-resp-ui";
let AggregatesIncidentsBlock = class AggregatesIncidentsBlock extends React.Component {
    constructor(props) {
        super(props);
        // setup dictionary
        this.dict = props.dict;
        // setup data provider
        this.state = {
            dataProvider: props.dataProvider
        };
    }
    render() {
        return (React.createElement("div", { className: "rj-incidents-wrapper" },
            React.createElement("ul", { className: "rj-incidents-content" }, this.state.dataProvider.isDataLoaded
                ?
                    React.createElement("div", { className: "rj-incidents-inner-wrapper" },
                        React.createElement(IncidentItem, { dict: this.dict, incident: this.state.dataProvider.latestIncident, iconClass: getPropertyValueOrDefault(IconTypes, this.state.dataProvider.latestIncident.type), badgeClass: getPropertyValueOrDefault(BadgeTypes, this.state.dataProvider.latestIncident.type), latestClasses: this.state.dataProvider.latestIncidentClass }),
                        React.createElement("div", { className: `rj-incidents-all-container ${this.state.dataProvider.allIncidentsClass}` }, this.state.dataProvider.incidents.map((incident) => (React.createElement(IncidentItem, { key: incident.id, dict: this.dict, incident: incident, iconClass: getPropertyValueOrDefault(IconTypes, incident.type), badgeClass: getPropertyValueOrDefault(BadgeTypes, incident.type), latestClasses: "" })))))
                : React.createElement(Message, { text: this.dict.NoIncidentsMessage }))));
    }
};
AggregatesIncidentsBlock = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], AggregatesIncidentsBlock);
export { AggregatesIncidentsBlock };
//# sourceMappingURL=AggregatesIncidentsBlock.js.map